import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BaseUrlService {

  /**
   * Renvoie la base de l'application (ex: "/StarterApp")
   */
  getBasePath(): string {
    const path = window.location.pathname;
    const parts = path.split('/').filter(Boolean);
    return parts.length > 0 ? `/${parts[0]}` : '/';
  }

  /**
   * Construit une URL d'API complète basée sur le chemin courant.
   * @param endpoint Exemple : "user/info"
   * @returns Exemple : "/StarterApp/api/user/info"
   */
  getApiUrl(endpoint: string): string {
    const base = this.getBasePath();
    return `${base}/api/${endpoint.replace(/^\/+/, '')}`;
  }
}